import React from 'react';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTurnDownLeft, faSparkles } from '@fortawesome/pro-regular-svg-icons';

import { List } from '@buildoutinc/blueprint-react/ui/List';

interface Props {
  active: boolean;
  query: string;
  onSelect: () => void;
}

export default function AskAiRow({ active, query, onSelect }: Props) {
  const trimmed = query.trim();

  return (
    <List flush>
      <List.Item
        asAction
        className={classNames('omni-search-ask-ai align-items-center border-0', {
          'omni-search-result--active': active,
        })}
        data-testid="omni-search-ask-ai"
        render={<button type="button" />}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          onSelect();
        }}
      >
        <span className="omni-search-ask-ai-icon d-flex align-items-center justify-content-center flex-shrink-0">
          <FontAwesomeIcon className="icon-gradient" icon={faSparkles} />
        </span>
        <List.ItemContent>
          <List.ItemTitle>Ask Otto</List.ItemTitle>
          <List.ItemDescription>
            {trimmed ? `"${trimmed}"` : 'Start a conversation'}
          </List.ItemDescription>
        </List.ItemContent>
        <List.ItemActions>
          <FontAwesomeIcon className="omni-search-ask-ai-enter" icon={faArrowTurnDownLeft} />
        </List.ItemActions>
      </List.Item>
    </List>
  );
}
